interface Props {
  open: boolean;
  onClose: () => void;
}

const SHORTCUTS: Array<{ keys: string; what: string; group: string }> = [
  { group: "History",  keys: "⌘ Z",        what: "Undo" },
  { group: "History",  keys: "⌘ ⇧ Z",      what: "Redo" },
  { group: "Save",     keys: "⌘ S",        what: "Save to library" },
  { group: "Export",   keys: "⌘ E",        what: "Brand Kit ZIP" },
  { group: "Export",   keys: "⌘ P",        what: "PNG export" },
  { group: "Export",   keys: "⌘ ⇧ S",      what: "Download source .json" },
  { group: "Layout",   keys: "1",          what: "Icon top" },
  { group: "Layout",   keys: "2",          what: "Icon left" },
  { group: "Layout",   keys: "3",          what: "Icon right" },
  { group: "Layout",   keys: "4",          what: "Text only" },
  { group: "Layout",   keys: "5",          what: "Icon only" },
  { group: "Editor",   keys: "Esc",        what: "Back to home" },
  { group: "Help",     keys: "?",          what: "Show / hide this overlay" },
];

export function ShortcutsHelp({ open, onClose }: Props) {
  if (!open) return null;
  const groups = Array.from(new Set(SHORTCUTS.map((s) => s.group)));
  return (
    <div className="shortcuts-overlay" onClick={onClose}>
      <div className="shortcuts-card" onClick={(e) => e.stopPropagation()}>
        <header>
          <h3>Keyboard Shortcuts</h3>
          <button className="flyout-close" onClick={onClose} aria-label="Close">×</button>
        </header>
        <div className="shortcuts-grid">
          {groups.map((g) => (
            <div key={g} className="shortcuts-group">
              <h4>{g}</h4>
              <ul>
                {SHORTCUTS.filter((s) => s.group === g).map((s) => (
                  <li key={s.keys + s.what}>
                    <kbd>{s.keys}</kbd>
                    <span>{s.what}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <footer>Press <kbd>?</kbd> anytime to toggle this overlay.</footer>
      </div>
    </div>
  );
}
